import React, { useState, useEffect, useRef } from "react";
import { auth } from "../../firebase/credenciales"; // Asegúrate de importar la instancia de autenticación desde tu archivo firebase.js
import NavbarPro from "./Components/NavBarPro";
import Navbar from "./Components/NavBarLite";
import "../css/consulta.css";
import emailjs from 'emailjs-com';

const App = () => {
  const [user, setUser] = useState(null);
  const [warningMessage, setWarningMessage] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const form = useRef();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        // El usuario está autenticado
        setUser(authUser);
      } else {
        // El usuario no está autenticado
        setUser(null);
      }
    });

    // Limpia el efecto cuando el componente se desmonta
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("body-consulta");
    return () => {
      document.body.classList.remove("body-consulta");
    };
  }, []);

  const validateForm = () => {
    const formElements = form.current.elements;
    for (let i = 0; i < formElements.length; i++) {
      if (formElements[i].tagName === 'INPUT' || formElements[i].tagName === 'TEXTAREA') {
        if (!formElements[i].value.trim()) {
          return false;
        }
      }
    }
    return true;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setWarningMessage('Todos los campos deben estar llenos.');
      setTimeout(()=> setShowWarning(true),1);
      setTimeout(() => setShowWarning(false), 3000); // Ocultar el mensaje después de 3 segundos
      return;
    }

    emailjs.sendForm('service_ltjulnk', 'template_sg7tuiq', form.current, 'HWxqW1vU-6IMWTdG6')
      .then((result) => {
          console.log(result.text);
          form.current.reset(); // Limpiar el formulario después de enviar el correo
          setWarningMessage(''); // Limpiar el mensaje de advertencia
          setTimeout(()=> setShowSuccess(true),1);
          setTimeout(() => setShowSuccess(false), 3000); // Ocultar el mensaje de éxito después de 3 segundos
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <div>
      {user ? <NavbarPro /> : <Navbar />}
      <div className="parent-consulta">
        <div className="child-consulta">
          <div className="form-consulta">
          <h1 className="tituloConsulta">Consultar</h1>
            <p>Dejenos sus datos para poder comunicarnos</p>
            <form ref={form} onSubmit={sendEmail}>
              <input type="text" id="nombre" name="nombre" placeholder="Nombre" />
              <input type="text" id="empresa" name="empresa" placeholder="Empresa" />
              <input type="text" id="email" name="email" placeholder="Email" />
              <input type="text" id="telefono" name="telefono" placeholder="Telefono" />
              <textarea id="mensaje" name="mensaje" placeholder="Escriba tu mensaje" className="mensaje"/>
              <input type="submit" value="Enviar consulta"/>
            </form>
          </div>
        </div>
      </div>
      {warningMessage && (
        <div className={`warning-message ${showWarning ? 'show' : ''}`}>
          {warningMessage}
        </div>
      )}
      {showSuccess && (
        <div className={`success-message ${showSuccess ? 'show' : ''}`}>
          El mensaje fue enviado
        </div>
      )}
    </div>
  );
};

export default App;
